import { MaintenanceBannerData } from '../../models';

import { UseContentSelector } from './UseContentSelector.ts';

export const MaintenanceBannerContent: UseContentSelector<MaintenanceBannerData[], MaintenanceBannerData[]> = {
  useResultSelector: (content) => content.maintenanceBanners,
  useDataSelector: (banners) => banners,
};
